export default function HelpReportsItemsService(gettext) {
  'ngInject';

  this.getModule = function () {
    let module = {
      id: 'analytics',
      name: gettext('Analytics'),
      description: gettext('The Analytics area is where reports can be generated and scheduled for delivery.'),
      icon: 'fas fa-question-circle',
      priority: 6,
      items: [
        {
          orderid: 6.1,
          itemid: 'reportsbase',
          helpitemid: 'analytics',
          name: gettext('Analytics'),
          templateUrl: 'reports/reports.html'
        },
        {
          orderid: 6.2,
          itemid: 'reportsDashboard',
          helpitemid: 'reportsDashboard',
          name: gettext('Dashboards'),
          templateUrl: 'reports/dashboard.html'
        },
        {
          orderid: 6.3,
          itemid: 'analyticsschedules',
          helpitemid: 'analytics.schedules',
          name: gettext('Analytics Schedules'),
          templateUrl: 'reports/reports.schedule.html'
        }
      ]
    };

    return module;
  };
}
